import Image from 'next/image'

import { VacanciesOverview } from '@/interfaces/schema'
import { useMediumScreen } from '@/hooks/useMediaQuery'
import useIsRay from '@/hooks/useIsRay'
import getBgImgStyles from '@/lib/bg-image'
import { GRID } from '@/lib/constants'
import Section from '@/layouts/section'
import Block from '@/layouts/block'
import { InputFieldSearch } from '@/components/input'
import { VacancyButton } from '@/components/button'
import FormElement from '@/components/form'
import { H1, H2 } from '@/components/typography'

type BannerVacanciesProps = Pick<
  VacanciesOverview,
  'bannerImage' | 'bannerIcon' | 'bannerTitle' | 'bannerSubtitle'
> & {
  handleInputSearchQueryChange: any
  searchQuery: string
  loading: boolean
  displayTextkernel: boolean
  handleDisplayTextkernel: (
    value: boolean
  ) => (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const Banner = ({
  handleInputSearchQueryChange,
  searchQuery,
  loading,
  displayTextkernel,
  handleDisplayTextkernel,
  bannerImage,
  bannerIcon,
  bannerTitle,
  bannerSubtitle,
}: BannerVacanciesProps) => {
  const isRay = useIsRay()
  const isMediumScreen = useMediumScreen()
  const imgHeight = 440
  const imgWidth = isMediumScreen ? 'calc(100% + 10px)' : 'calc(100% + 80px)'

  const bg = !isMediumScreen
    ? getBgImgStyles({
        url: bannerImage?.url ?? '',
        height: imgHeight,
        width: imgWidth,
        parallax: false,
      })
    : undefined

  return (
    <Section
      styles={bg}
      className="relative rounded-sm w-full !max-w-[1360px] mb-[30px] lg:mb-[120px] mx-auto"
    >
      <Block className={`${GRID} mx-[5px] lg:mx-[40px]`}>
        <Block className={`vacanciesBanner__card ${GRID}`}>
          <div className="vacanciesBanner__intro">
            <div className="flex items-center">
              <Image
                src={bannerIcon?.url ?? ''}
                height={isMediumScreen ? 30 : 40}
                width={isMediumScreen ? 18 : 30}
                objectFit="contain"
                alt=""
                className="w-[30px] md:w-[70px]"
              />
              <H1 className="ml-[15px]">{bannerTitle}</H1>
            </div>
            <H2>{bannerSubtitle}</H2>
          </div>
          {isRay && (
            <div className="vacanciesBanner__buttons">
              <VacancyButton
                isActive={!displayTextkernel}
                onClick={handleDisplayTextkernel(false)}
              >
                Rvdb vacatures
              </VacancyButton>
              <VacancyButton
                isActive={displayTextkernel}
                onClick={handleDisplayTextkernel(true)}
              >
                Alle HR vacatures van NL
              </VacancyButton>
            </div>
          )}
          {!displayTextkernel && (
            <FormElement
              wrapperClassName="vacanciesBanner__search"
              initialValues={{ search: '' }}
              submitForm={handleInputSearchQueryChange}
            >
              <InputFieldSearch
                placeholder="Zoek een HR vacature..."
                onChange={handleInputSearchQueryChange}
                name="search"
                value={searchQuery}
                loading={loading}
              />
            </FormElement>
          )}
        </Block>
      </Block>
    </Section>
  )
}
